import React, { useEffect } from 'react'
import Header2 from '../../layout/Header2'
import ServicesBanner from '../../components/haseeb/ServicesBanner'
import { useLanguage } from '../../contexts/LanguageContext'
import BannerImg from '../../assets/images/bannners/AppDevelopment.webp'
import Img1 from '../../assets/images/app-development/Img1.webp'
import Img2 from '../../assets/images/app-development/Img2.webp'
import Img3 from '../../assets/images/app-development/Img3.webp'
import { Col, Row } from 'reactstrap'
import { FaDotCircle } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import { ChevronRight } from 'react-bootstrap-icons'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import ReadMoreOrLess from '../../components/haseeb/ReadMoreOrLess'

const AppDevelopment = () => {
    const { t } = useLanguage();
    
    useEffect(() => {
        window.scrollTo(0,0);
    },[])
    
    return (
    <>
    <HelmetProvider>
    <Helmet prioritizeSeoTags>
        <title>software development & digital marketing agency in Germany - IT Junction </title>
    </Helmet>
    </HelmetProvider>
    <Header2/>
    <ServicesBanner
    BannerImg={BannerImg}
    SubTitle={t('servicePages.appDevelopment.subtitle')}
    Title={t('servicePages.appDevelopment.title')}
    />
<section id='website-responsive' className="container-fluid px-0">
<div id='website-responsive' className=''>
        <div className='container-fluid ps-lg-5 ps-4 py-lg-5 py-4'>
            <Row className=''>
                <Col lg='3' className='pb-5'>
                    <div className='pb-md-3 pb-lg-0 pb-3'>
                        <div className='d-flex align-items-center'>
                            <FaDotCircle className='text-ss-primary me-3'/>
                                <Link to='/services/healthcare-solutions' className='' style={{ textDecoration:'none', cursor:'pointer'}}>
                            <span className='fs-ss-18 text-mulish fw-500 text-ss-black'>
                                    {t('services.healthcareSolutions')}
                            </span>
                                </Link>
                        </div>
                        <div className='d-flex align-items-center mt-3'>
                            <FaDotCircle className='text-ss-primary me-3'/>
                                <Link to='/services/branding/' className='' style={{ textDecoration:'none', cursor:'pointer'}}>
                            <span className='fs-ss-18 text-mulish fw-500 text-ss-black'>
                                    {t('services.branding')}
                            </span>
                                </Link>
                        </div>
                        <div className='d-flex align-items-center mt-3'>
                            <FaDotCircle className='text-ss-primary me-3'/>
                                <Link to='/services/graphic-designing' className='' style={{ textDecoration:'none', cursor:'pointer'}}>
                            <span className='fs-ss-18 text-mulish fw-500 text-ss-black'>
                                    {t('services.graphicDesigning')}
                            </span>
                                </Link>
                        </div>
                        <div className='d-flex align-items-center mt-3'>
                            <FaDotCircle className='text-ss-primary me-3'/>
                                <Link to='/services/content-writing/' className='' style={{ textDecoration:'none', cursor:'pointer'}}>
                            <span className='fs-ss-18 text-mulish fw-500 text-ss-black'>
                                    {t('services.contentWriting')}
                            </span>
                                </Link>
                        </div>
                        <div className='d-flex align-items-center mt-3'>
                            <FaDotCircle className='text-ss-primary me-3'/>
                                <Link to='/services/web-development/' className='' style={{ textDecoration:'none', cursor:'pointer'}}>
                            <span className='fs-ss-18 text-mulish fw-500 text-ss-black'>
                                    {t('services.webDevelopment')}
                            </span>
                                </Link>
                        </div>
                        <div className='d-flex align-items-center mt-3'>
                            <FaDotCircle className='text-ss-primary me-3'/>
                                <Link to='/services/app-development/' className='' style={{ textDecoration:'none', cursor:'pointer'}}>
                            <span className='fs-ss-24 text-mulish fw-500 text-ss-primary'>
                                    {t('services.appDevelopment')}
                            </span>
                                </Link>
                        </div>
                        <div className='d-flex align-items-center mt-3'>
                            <FaDotCircle className='text-ss-primary me-3'/>
                                <Link to='/services/search-engine-optimization/' className='' style={{ textDecoration:'none', cursor:'pointer'}}>
                            <span className='fs-ss-18 text-mulish fw-500 text-ss-black'>
                                    {t('services.seo')}
                            </span>
                                </Link>
                        </div>
                        <div className='d-flex align-items-center mt-3'>
                            <FaDotCircle className='text-ss-primary me-3'/>
                                <Link to='/services/social-media-marketing/' className='' style={{ textDecoration:'none', cursor:'pointer'}}>
                            <span className='fs-ss-18 text-mulish fw-500 text-ss-black'>
                                {t('services.socialMediaMarketing')}
                            </span>
                                </Link>
                        </div>
                        <div className='d-flex align-items-center mt-3'>
                            <FaDotCircle className='text-ss-primary me-3'/>
                                <Link to='/services/video-animation/' className='' style={{ textDecoration:'none', cursor:'pointer'}}>
                            <span className='fs-ss-18 text-mulish fw-500 text-ss-black'>
                                {t('services.videoAnimation')}
                            </span>
                                </Link>
                        </div>
                        <div className='d-flex align-items-center mt-3'>
                            <FaDotCircle className='text-ss-primary me-3'/>
                                <Link to='/services/ppc-marketing/' className='' style={{ textDecoration:'none', cursor:'pointer'}}>
                            <span className='fs-ss-18 text-mulish fw-500 text-ss-black'>
                                {t('services.ppcMarketing')}
                            </span>
                                </Link>
                        </div>
                    </div>
                </Col>

                <Col className='ps-lg-4 d-none d-lg-block'>
                        <div className='d-block d-lg-flex align-items-start'>
                          <div className='w-75'>
                          <div className='mb-lg-4 mb-3'>
                            <h2 className='fs-ss-36 text-philos fw-800 text-ss-black'>
                            {t('servicePages.appDevelopment.expertiseTitle')}
                            </h2>
                        </div>
                        <ReadMoreOrLess
                        Para={t('servicePages.appDevelopment.expertiseDescription')}
                        limit={488}
                        />
                            </div>
                            <div className='px-lg-5'>
                            <img className='' src={Img1} alt="Web Dev" style={{width:"400px"}} />
                        </div>
                    </div>
                </Col>

                <Col className='d-block d-lg-none'>
                          <div className='mb-lg-4 mb-3'>
                            <h2 className='fs-ss-36 text-philos fw-800 text-ss-black'>
                            {t('servicePages.appDevelopment.expertiseTitle')}
                            </h2>
                        </div>
                            <p className='fs-ss-16 text-mulish fw-500 text-ss-black lh-1-8'>
                            Have you ever considered that our world is at the forefront of technology and that info on anything is just a click away? Information is readily available, society is developing quickly, and people prefer simple procedures when scheduling a health checkup. Similarly, to <Link className='text-decoration-none text-ss-primary' to="/packages"> advance your business, </Link> app development services are essential. Have you ever considered that our world is at the forefront of technology and that info on anything is just a click away? Information is readily available, society is developing quickly, and people prefer simple procedures when scheduling a health checkup. Similarly, to advance your business, app development services are essential. We have much experience in making apps for iPhones and iPads. Our team knows about Apple’s way of doing things, and we pay much attention to creating apps that work great and look great. Our developers are good at using Swift, Objective-C, and the newest iOS tools. We’re ready to take your app idea and make it real from the start to when it’s available for people to use. Whether you’re making an app for fun, games, or serious business, we’re here to help make it awesome. Count on <Link className='text-decoration-none text-ss-primary' to="/"> IT Junction </Link> for top-notch iOS app making. We’re experts who know how to make great apps that people love. 
                            </p>
                            <div className='px-lg-5'>
                            <img className='w-100' src={Img1} alt="Web Dev"/>
                    </div>
                </Col>
            </Row>
        </div>
    </div>

    <section className="container-fluid pb-4">
      <div className='row justify-content-evenly align-items-center'>
        <div className="col-11 col-md-9">
        <div className='mb-4'>
        <div className='mb-3'>
             <div className='fs-ss-36 text-philos fw-800 text-ss-black lh-sm text-start text-lg-center'>
             {t('servicePages.appDevelopment.brandRecognitionTitle')}
             </div>
         </div>
         <div className=''>
             <p className='fs-ss-16 text-mulish fw-500 text-ss-black lh-1-8'>
             {t('servicePages.appDevelopment.brandRecognitionDescription')}
             </p>
        </div>
        </div>

        <div className='mb-4'>
        <div className='mb-3'>
             <div className='fs-ss-36 text-philos fw-800 text-ss-black lh-sm text-start text-lg-center'>
             {t('servicePages.appDevelopment.customerExperienceTitle')}
             </div>
         </div>
         <div className=''>
             <p className='fs-ss-16 text-mulish fw-500 text-ss-black lh-1-8'>
             {t('servicePages.appDevelopment.customerExperienceDescription')}
             </p>
        </div>
        </div>

        <div className='mb-4'>
        <div className='mb-3'>
             <div className='fs-ss-36 text-philos fw-800 text-ss-black lh-sm text-start text-lg-center'>
             {t('servicePages.appDevelopment.increasedSalesTitle')}
             </div>
         </div>
         <div className=''>
             <p className='fs-ss-16 text-mulish fw-500 text-ss-black lh-1-8'>
             {t('servicePages.appDevelopment.increasedSalesDescription')}
             </p>
        </div>
        </div>
        </div>
      </div>
    </section>

    <section className="container-fluid py-5 bg-ss-primary text-white text-center">
      <div className='row justify-content-evenly align-items-center'>
      <div className="col-11 col-xl-8 fs-ss-42 text-philos fw-800 ">
         <div className=''>
         {t('servicePages.appDevelopment.brilliantMindsTitle')}
        </div>
        </div>

        <div className="col-11 col-xl-2">
         <div className=''>
         <div className='pt-4'>
            <Link to="/contact" className="text-decoration-none text-white fs-ss-18 fw-500 border-2 border-white border py-2 px-3"> {t('contact.title')} <ChevronRight className='fs-ss-22'/> </Link>
        </div>
        </div>
        </div>
      </div>
    </section>

    <section className="container-fluid py-4 py-lg-5">
      <div className='row justify-content-evenly align-items-center gy-4'>
        <div className="col-11 col-md-5">
          <img className='w-100' src={Img2} alt="" />
        </div>
        <div className="col-11 col-md-5">
        <div className='mb-lg-4 mb-3'>
             <div className='fs-ss-36 text-philos fw-800 text-ss-black lh-sm'>
             {t('servicePages.appDevelopment.customSolutionsTitle')}
             </div>
         </div>
         <div className=''>
             <p className='fs-ss-16 text-mulish fw-500 text-ss-black lh-1-8'>
             {t('servicePages.appDevelopment.customSolutionsDescription')}             
             </p>
        </div>
        </div>
      </div>
    </section>

    <section className="container-fluid py-4">
      <div className='row justify-content-evenly align-items-center'>
        <div className="col-11">
        <div className='mb-lg-4 mb-3'>
             <div className='fs-ss-36 text-philos fw-800 text-ss-black lh-sm text-start text-lg-center'>
             {t('servicePages.appDevelopment.customerDataTitle')}
             </div>
         </div>
         <div className=''>
             <p className='fs-ss-16 text-mulish fw-500 text-ss-black lh-1-8'>
             {t('servicePages.appDevelopment.customerDataDescription')}
             </p>
        </div>

        <div className='mb-4'>
        <div className='mb-3'>
             <div className='fs-ss-36 text-philos fw-800 text-ss-black lh-sm text-start text-lg-center'>
             {t('servicePages.appDevelopment.qualityWorkTitle')}
             </div>
         </div>
         <div className=''>
             <p className='fs-ss-16 text-mulish fw-500 text-ss-black lh-1-8'>
             {t('servicePages.appDevelopment.qualityWorkDescription')}
             </p>
        </div>
        </div>

        <div className='mb-4'>
        <div className='mb-3'>
             <div className='fs-ss-36 text-philos fw-800 text-ss-black lh-sm text-start text-lg-center'>
             {t('servicePages.appDevelopment.supportMaintenanceTitle')}
             </div>
         </div>
         <div className=''>
             <p className='fs-ss-16 text-mulish fw-500 text-ss-black lh-1-8'>
             {t('servicePages.appDevelopment.supportMaintenanceDescription')} 
             </p>
        </div>
        </div>
        </div>
      </div>
    </section>

    <section className="container-fluid py-4 py-lg-5">
      <div className='row justify-content-evenly align-items-center gy-4'>
        <div className="col-11 col-md-5">
        <div className='mb-lg-4 mb-3'>
             <div className='fs-ss-36 text-philos fw-800 text-ss-black lh-sm'>
             {t('servicePages.appDevelopment.enterpriseGermanyTitle')}
             </div>
         </div>
         <div className=''>
             <p className='fs-ss-16 text-mulish fw-500 text-ss-black lh-1-8'>
             {t('servicePages.appDevelopment.enterpriseGermanyDescription')} 
             </p>
        </div>
        </div>
        <div className="col-11 col-md-5">
          <img className='w-100' src={Img3} alt="" />
        </div>
      </div>
    </section>

    <section className="container-fluid pb-4">
      <div className='row justify-content-evenly align-items-center'>
        <div className="col-11">
        <div className='mb-lg-4 mb-3'>
             <div className='fs-ss-36 text-philos fw-800 text-ss-black lh-sm text-center'>
             {t('servicePages.appDevelopment.gameChangingTitle')}
             </div>
         </div>
         <div className=''>
             <p className='fs-ss-16 text-mulish fw-500 text-ss-black lh-1-8'>
             {t('servicePages.appDevelopment.gameChangingDescription')} 
             </p>
        </div>
        </div>
      </div>
    </section>

    <section className="container-fluid pb-4">
      <div className='row justify-content-evenly align-items-center'>
        <div className="col-11">
        <div className='mb-lg-4 mb-3'>
             <div className='fs-ss-36 text-philos fw-800 text-ss-black lh-sm text-center'>
             {t('servicePages.appDevelopment.smallToBigTitle')} 
             </div>
         </div>
         <div className=''>
             <p className='fs-ss-16 text-mulish fw-500 text-ss-black lh-1-8'>
             {t('servicePages.appDevelopment.smallToBigDescription')}
             </p>
        </div>
        </div>
      </div>
    </section>
    </section>
    </>
  )
}

export default AppDevelopment